import { useSelector } from 'react-redux';
import { marketSupportsSvcOnboardingAuth } from '~/constants/markets';
import { RootState } from '~/store';

export const useShouldUseSvcOnboardingAuth = () => {
  const market = useSelector((state: RootState) => state.intl.market);
  return marketSupportsSvcOnboardingAuth(market, window.location.pathname);
};
